export default {
  container: {
    xs: 10,
    sm: 24,
    md: 60,
    lg: 60,
    xl: 60,
  },
};
